<template>
  <div class="my-work container" id="myworks-section">
    <h1>My Work</h1>
    <div class="row justify-content-center">
      <!-- project -->
      <div class="project-container col-md-3 p-0 m-2">
        <a
          href="https://next-dashboard-zeta-tawny.vercel.app/dashboard"
          target="_blank"
          class="btn p-0"
        >
          <div class="project card mb-4">
            <img
              src="../assets/images/projects-logo/project-logo-1.png"
              class="card-img-top"
              alt="project-image"
            />
            <h5 class="card-title p-3">Next Admin Dashboard</h5>
          </div>
        </a>
        <!-- source code link -->
        <a
          class="github-icon"
          href="https://github.com/fathi-fayez/next-dashboard"
          target="_blank"
          title="View source code"
          ><i class="fa-brands fa-github" style="color: #4078c0"></i
        ></a>
      </div>

      <!-- project -->
      <div class="project-container col-md-3 p-0 m-2">
        <a
          href="https://react-leando-e-commerce-kc4h.vercel.app/"
          target="_blank"
          class="btn p-0"
        >
          <div class="project card mb-4">
            <img
              src="../assets/images/projects-logo/project-logo-2.png"
              class="card-img-top"
              alt="project-image"
            />
            <h5 class="card-title p-3">Leando E-commerce</h5>
          </div>
        </a>
        <!-- source code link -->
        <a
          class="github-icon"
          href="https://github.com/fathi-fayez/react-leando-e-commerce"
          target="_blank"
          title="View source code"
          ><i class="fa-brands fa-github" style="color: #4078c0"></i
        ></a>
      </div>

      <!-- project -->
      <div class="project-container col-md-3 p-0 m-2 rounded">
        <a
          href="https://cafvy.web-pioneer.cloud/"
          target="_blank"
          class="btn p-0"
        >
          <div class="project card mb-4">
            <img
              src="../assets/images/projects-logo/project-logo-9.png"
              class="card-img-top"
              alt="project-image"
            />
            <h5 class="card-title p-3">Cafvy booking app</h5>
          </div>
        </a>
      </div>

      <!-- project -->
      <div class="project-container col-md-3 p-0 m-2">
        <a
          href="https://wisdom-store.vercel.app/"
          target="_blank"
          class="btn p-0"
        >
          <div class="project card mb-4">
            <img
              src="../assets/images/projects-logo/project-logo-8.png"
              class="card-img-top"
              alt="project-image"
            />
            <h5 class="card-title p-3">Wisdom Store</h5>
          </div>
        </a>
        <!-- source code link -->
        <a
          class="github-icon"
          href="https://github.com/fathi-fayez/wisdom-store"
          target="_blank"
          title="View source code"
          ><i class="fa-brands fa-github" style="color: #4078c0"></i
        ></a>
      </div>
      <!-- project -->
      <div class="project-container col-md-3 p-0 m-2">
        <a
          href="https://react-food-delivery-app-chi.vercel.app/"
          target="_blank"
          class="btn p-0"
        >
          <div class="project card mb-4">
            <img
              src="../assets/images/projects-logo/project-logo-10.png"
              class="card-img-top"
              alt="project-image"
            />
            <h5 class="card-title p-3">Tasty Food App</h5>
          </div>
        </a>
        <!-- source code link -->
        <a
          class="github-icon"
          href="https://github.com/fathi-fayez/react-food-delivery-app"
          target="_blank"
          title="View source code"
          ><i class="fa-brands fa-github" style="color: #4078c0"></i
        ></a>
      </div>
      <!-- project -->
      <div class="project-container col-md-3 p-0 m-2">
        <a
          href="https://admin-dashboard-xi-lime.vercel.app/"
          target="_blank"
          class="btn p-0"
        >
          <div class="project card mb-4">
            <img
              src="../assets/images/projects-logo/project-logo-6.png"
              class="card-img-top"
              alt="project-image"
            />
            <h5 class="card-title p-3">Admin dashboard</h5>
          </div>
        </a>
        <!-- source code link -->
        <a
          class="github-icon"
          href="https://github.com/fathi-fayez/admin-dashboard"
          target="_blank"
          title="View source code"
          ><i class="fa-brands fa-github" style="color: #4078c0"></i
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "myWorks",
  data() {
    return {
      works: [
        {
          title: "Project 1",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          image: "https://via.placeholder.com/300",
          link: "#",
        },
        {
          title: "Project 2",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          image: "https://via.placeholder.com/300",
          link: "#",
        },
        {
          title: "Project 3",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          image: "https://via.placeholder.com/300",
          link: "#",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.my-work {
  padding-top: 100px;
  padding-bottom: 100px;

  h1 {
    margin-bottom: 40px;
  }

  .project-container {
    width: 300px;
    height: 200px;
    transition: 0.5s;
    box-shadow: 0px 12px 20px 0px rgb(0 0 0 / 13%),
      0px 2px 4px 0px rgb(0 0 0 / 12%);
    position: relative;
    overflow: hidden;

    .card-img-top {
      width: 100%;
    }
  }

  .project-container:hover {
    .github-icon {
      bottom: 3px;
    }
  }

  .project {
    overflow: hidden;
    position: relative;
  }

  .project::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgb(3 169 244 / 18%);
    width: 0;
    height: 0;
    transition: 3s;
    opacity: 0;
    z-index: 2;
  }

  .project:hover::before {
    animation: flashing 0.8s;
  }

  .project:hover {
    h5 {
      color: rgb(42, 13, 235);
    }
  }

  .github-icon {
    position: absolute;
    left: 10px;
    bottom: -50px;
    font-size: 35px;
    transition: 0.3s;
  }

  .github-icon:hover {
    font-size: 40px;
  }
}

@keyframes flashing {
  0%,
  40% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    width: 200%;
    height: 200%;
  }
}
</style>
